<script lang="ts" setup>
import { EvaluationResults } from "types/EvaluationResults";

const props = defineProps({
  evaluationResults: {
    type: Object as PropType<EvaluationResults>,
    required: true,
  },
  expectedResults: {
    type: Object as PropType<EvaluationResults>,
    required: false,
  },
  showExpectedResults: {
    type: Boolean,
    default: false,
  },
  showLabels: {
    type: Boolean,
    default: false,
  },
  showTokenData: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(["setExpectedResults", "clearExpectedResults"]);

const showHiddenCriteria = ref(false);
const toggleShowHiddenCriteria = () => {
  showHiddenCriteria.value = !showHiddenCriteria.value;
};

const evaluatedResults = computed(() => {
  return props.evaluationResults;
});

const evaluatedExpectedResults = computed(() => {
  if (!props.expectedResults) return undefined;

  return props.expectedResults;
});
</script>

<template>
  <div class="flex flex-col items-start">
    <div class="flex flex-row justify-between">
      <div class="flex flex-col mr-4 border-r pr-4">
        <label class="font-bold mb-2 flex flex-row items-center">
          <span class="underline"> Test Results </span>
          <BaseIconButton
            @click="toggleShowHiddenCriteria"
            class="ml-2"
            :class="{
              ' bg-primary-default bg-opacity-20': showHiddenCriteria,
            }"
          >
            <icon name="grommet-icons:tree" />
          </BaseIconButton>
          <span class="mx-2"> - </span>
          <BaseTextButton
            @click="$emit('setExpectedResults', evaluationResults)"
            v-if="evaluationResults.id != expectedResults?.id"
          >
            Set as Expected Results
          </BaseTextButton>
          <span v-else class="text-success-default font-normal">
            Expected Result
          </span>
        </label>

        <DocumentProblemReviewTestingTree
          class="px-4"
          v-if="evaluatedResults"
          :evaluation-results="evaluatedResults.evaluationResult"
          :token-data="evaluationResults.tokenData"
          :show-token-data="showTokenData"
          :show-hidden-criteria="showHiddenCriteria"
        />
      </div>
      <TransitionsCollapsible>
        <div
          class="flex flex-col pt-2"
          v-if="evaluatedExpectedResults && showExpectedResults"
        >
          <label class="font-bold underline mb-2"> Expected Results </label>
          <DocumentProblemReviewTestingTree
            class="px-4"
            :evaluation-results="evaluatedExpectedResults.evaluationResult"
            :token-data="evaluatedExpectedResults.tokenData"
            :show-token-data="showTokenData"
            :show-hidden-criteria="showHiddenCriteria"
          />
        </div>
      </TransitionsCollapsible>
    </div>
    <BaseTextButton
      v-if="evaluationResults.id == expectedResults?.id"
      @click="emit('clearExpectedResults')"
      class="mb-2"
    >
      Clear Expected Results
    </BaseTextButton>
  </div>
</template>

<style scoped></style>
